import {API, BASE_URL} from './config';

export default {
    customizedData: async ()=>{
        try {
            const response = await API.get(`${BASE_URL}/webapi/customized-data`);
            return response;
        } catch (error) {
            console.log('error', error)
            return error.response;
        }
    },

    getData: async ()=>{
        try {
            const response = await API.get(`http://localhost:5000/cpaysolu-finance/fin-assessment-bill`);
            return response;
        } catch (error) {
            console.log('error', error)
            return error.response;
        }
    },

    dynamicPage: async (url)=>{
        try {
            const response = await API.get(`${BASE_URL}/webapi/dynamic-page/${url}`);
            return response;
        } catch (error) {
            console.log('error', error)
            return error.response;
        }
    }
}